import type { ComponentProps, ReactElement } from 'react';
import type { CollapseProps } from 'antd';
import {
  ApiOutlined,
  SafetyCertificateOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { SIPAccountBasicFields } from './SIPAccountBasicFields';
import { SIPAccountRegistrationFields } from './SIPAccountRegistrationFields';
import {
  SIPAccountHeaderFields,
  SIPAccountIdentityFields,
  SIPAccountNetworkFields,
} from './SIPAccountExtraFields';
import styles from './style.module.css';

const createPanelLabel = (
  icon: ReactElement,
  title: string,
  subtitle?: string,
) => (
  <div className={styles.panelLabel}>
    <div className={styles.panelLabelRow}>
      {icon}
      <span className={styles.panelTitle}>{title}</span>
    </div>
    {subtitle ? <span className={styles.panelSubtitle}>{subtitle}</span> : null}
  </div>
);

export const createSipAccountPanels = (
  props: ComponentProps<typeof SIPAccountBasicFields>,
): CollapseProps['items'] => {
  const basicPanel = {
    key: 'basic',
    label: createPanelLabel(
      <ApiOutlined className={styles.panelIcon} />,
      'Основные параметры',
    ),
    children: <SIPAccountBasicFields {...props} />,
  };

  if (!props.isCreateMode) return [basicPanel];

  return [
    basicPanel,
    {
      key: 'network',
      label: createPanelLabel(
        <ApiOutlined className={styles.panelIcon} />,
        'Сетевые настройки',
        'Прокси-сервер и адрес регистрации',
      ),
      children: <SIPAccountNetworkFields />,
    },
    {
      key: 'registration',
      label: createPanelLabel(
        <SettingOutlined className={styles.panelIcon} />,
        'Параметры регистрации',
        'Настройки регистрации и таймауты',
      ),
      children: <SIPAccountRegistrationFields />,
    },
    {
      key: 'identity',
      label: createPanelLabel(
        <SafetyCertificateOutlined className={styles.panelIcon} />,
        'SIP-идентификация',
        'Идентификаторы и контактные данные',
      ),
      children: <SIPAccountIdentityFields />,
    },
    {
      key: 'headers',
      label: createPanelLabel(
        <SafetyCertificateOutlined className={styles.panelIcon} />,
        'SIP-заголовки',
        'Дополнительные заголовки и параметры',
      ),
      children: <SIPAccountHeaderFields />,
    },
  ];
};
